// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PMoneyCollectOutlinedSvg from "@fishx/icons-svg/es/asn/PMoneyCollectOutlined";
import FishxIcon from '../components/FishxIcon';

var PMoneyCollectOutlined = function PMoneyCollectOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PMoneyCollectOutlinedSvg
  }));
};

PMoneyCollectOutlined.displayName = 'PMoneyCollectOutlined';
export default React.forwardRef(PMoneyCollectOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PMoneyCollectOutlined.js
// module id = 3513
// module chunks = 0